import { styled } from '@ori-ui/mui';
import { LocalizationItem } from '../../constants';
import { CustomerCategory } from '../../models';
import { useConsultantNameFormatters } from '../../utils/useConsultantNameFormatters';
import { LocalizedText } from '../LocalizedText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Container = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateColumns: '1fr',
    gridTemplateRows: "auto minmax(".concat(theme.spacing(2), ", auto)"),
    width: '100%',
    borderBottom: "2px solid ".concat(theme.palette.grey[100]),
    '& link': {
      display: 'block',
      padding: theme.spacing(2, 3, 2, 3)
    }
  };
});
var Info = styled('div')(function (_ref2) {
  var theme = _ref2.theme;
  return {
    alignSelf: 'center',
    padding: theme.spacing(2, 3, 2, 3),
    color: theme.palette.grey[900],
    fontSize: '12px',
    fontWeight: 'bold'
  };
});
var Name = styled('span')(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: 'block',
    overflow: 'hidden',
    fontSize: '18px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  };
});
var Action = styled('div')(function (_ref4) {
  var theme = _ref4.theme;
  return {
    padding: theme.spacing(0, 3, 3)
  };
});
var Button = styled('a')(function (_ref5) {
  var theme = _ref5.theme;
  return {
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    height: theme.spacing(6),
    paddingTop: theme.spacing(1),
    borderRadius: theme.spacing(1),
    background: theme.palette.grey[100],
    color: theme.palette.grey[700],
    fontSize: '14px',
    fontWeight: 'bold',
    textAlign: 'center'
  };
});
export var Personalisation = function Personalisation(_ref6) {
  var user = _ref6.user,
    upgradeToConsultantUrl = _ref6.upgradeToConsultantUrl,
    upgradeToBrandPartnerUrl = _ref6.upgradeToBrandPartnerUrl;
  var _useConsultantNameFor = useConsultantNameFormatters(),
    getFormattedConsultantName = _useConsultantNameFor.getFormattedConsultantName;
  if (user.UserType === CustomerCategory.Employee) {
    return null;
  }
  var upgradeToConsultant = null;
  if (user.UserType === CustomerCategory.EndCustomer && upgradeToConsultantUrl) {
    upgradeToConsultant = /*#__PURE__*/_jsx(Action, {
      children: /*#__PURE__*/_jsx(Button, {
        href: upgradeToConsultantUrl,
        children: /*#__PURE__*/_jsx(LocalizedText, {
          localizationItem: LocalizationItem.UpgradeToConsultant
        })
      })
    });
  }
  var upgradeToBrandPartner = null;
  if (user.UserType === CustomerCategory.EndCustomer && upgradeToBrandPartnerUrl) {
    upgradeToBrandPartner = /*#__PURE__*/_jsx(Action, {
      children: /*#__PURE__*/_jsx(Button, {
        href: upgradeToBrandPartnerUrl,
        children: /*#__PURE__*/_jsx(LocalizedText, {
          localizationItem: LocalizationItem.UpgradeToBrandPartner
        })
      })
    });
  }
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs(Info, {
      children: [/*#__PURE__*/_jsx(LocalizedText, {
        localizationItem: LocalizationItem.Hello
      }), ",", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Name, {
        children: getFormattedConsultantName(user.FirstName, user.LastName)
      })]
    }), upgradeToConsultant, upgradeToBrandPartner]
  });
};